import '../tools-pages.css'

import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { Spinner } from '../../Components'
import { FC, useCQuery } from '../../Services'
import { cap } from '../../State'
import { translations } from '../../translations'
import { showToast } from '../../utils/toast'
import { columnProps } from '../Prompts/Functions'
import { useDefaultChatData } from './AutoTest/Functions'
import testConv from './AutoTest/testConv.json'

const language = cap.language.state || 'IT'
const t = translations[language]

export const AutoTestsList = () => {
  const { data: AutoTests, isSuccess } = useCQuery(['autoTests'])
  const navigate = useNavigate()
  const { isSuccess: isSuccessDataChat, ...data } = useDefaultChatData()

  const BtnActions = ({ id }) => (
    <button
      type="button"
      className="naction-btn naction-btn--primary"
      title={t.open}
      onClick={() => navigate('/autotest/' + id)}
    >
      <i className="pi pi-eye" style={{ fontSize: 15 }} />
    </button>
  )

  const [isRunningLocalTests, setIsRunningLocalTests] = useState(false)

  const runAllTests = () => FC.service('info').create({ action: 'runAllTests', chatData: data })

  /**
   * Importa tutte le conversazioni dal file locale testConv.json nel database
   * Se una conversazione con conversationId è già presente, viene saltata
   * Dopo l'importazione, lancia runAllTests
   */
  const runLocalTests = async () => {
    if (!isSuccessDataChat) {
      showToast('error', t.errore, t.datiChatNonDisponibili)
      return
    }

    setIsRunningLocalTests(true)
    try {
      const tests = testConv?.data || []

      const importResult = await FC.service('info').create({
        action: 'importConversationsFromJson',
        conversations: tests
      })

      showToast(
        'success',
        t.importazioneCompletata,
        `${importResult.inserted} ${t.conversazioniInserite}, ${importResult.skipped} ${t.saltateGiaPresenti}`
      )
    } catch (error) {
      showToast('error', t.errore, `${t.erroreDuranteImportazione} ${error.message}`)
    } finally {
      setIsRunningLocalTests(false)
    }
  }

  if (!isSuccess) return <Spinner />
  return (
    <div className="autotest-page">
      <div className="nora-page__head">
        <div>
          <h1 className="nora-page__title">{t.autoTestTitle}</h1>
          <p className="nora-page__sub">{t.autoTestSubtitle}</p>
        </div>
        <div className="nora-page__actions">
          <button
            type="button"
            className="nbtn"
            onClick={runLocalTests}
            disabled={isRunningLocalTests || !isSuccessDataChat}
          >
            <i className="pi pi-upload" style={{ fontSize: 14 }} />
            {isRunningLocalTests ? t.caricamentoInCorso : t.caricaTestConv}
          </button>
          <button type="button" className="nbtn nbtn--primary" onClick={runAllTests}>
            <i className="pi pi-play" style={{ fontSize: 14 }} />
            {t.lanciaTuttiITest}
          </button>
        </div>
      </div>

      <div className="ncard" style={{ padding: 0 }}>
        <div className="ncard__head">
          <div className="ncard__ico">
            <i className="pi pi-play" style={{ fontSize: 16 }} />
          </div>
          <div>
            <h3 className="ncard__title">{t.test}</h3>
          </div>
        </div>
        <DataTable
          style={{ width: '100%' }}
          filterDisplay="row"
          sortField="createdAt"
          sortOrder={-1}
          className="TableSignatures"
          value={AutoTests}
          emptyMessage={t.nessunTestTrovato}
          responsiveLayout="scroll"
          paginator
          rows={12}
        >
          <Column
            field="id"
            {...columnProps(t.id)}
            body={({ id }) => <span className="ntable__num">#{id}</span>}
          />
          <Column
            field="messages.0.message"
            {...columnProps(t.messaggio)}
            body={({ messages }) => (
              <span
                style={{
                  color: 'var(--ink-900)',
                  fontSize: 13,
                  maxWidth: 0,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  display: 'block'
                }}
              >
                {messages?.[0]?.message}
              </span>
            )}
          />
          <Column
            headerStyle={{ visibility: 'hidden' }}
            style={{ border: 'none', width: 80, textAlign: 'center' }}
            body={(props) => <BtnActions {...props} />}
          />
        </DataTable>
      </div>
    </div>
  )
}
